import React, { useEffect } from "react";
import MainMenu from "../components/MainMenu"
import SocialLinks from "./SocialLinks";
import MarqueeSection from "../components/MarqueeSection";
import useScrollEffect from "../hooks/useScrollEffect";
import useToggle from "../hooks/useToggle";

const Header = () => {
  const isScrolled = useScrollEffect(50);
  const [sideMenuOpen, toggleSideMenu] = useToggle(false);

  // Close side menu when clicking outside
  useEffect(() => {
    if (sideMenuOpen) {
      const handleOutsideClick = (e) => {
        // If click is outside the side menu and not on the toggle button
        if (!e.target.closest('.side') && !e.target.closest('.side-menu')) {
          toggleSideMenu();
        }
      };

      document.addEventListener('mousedown', handleOutsideClick);

      return () => {
        document.removeEventListener('mousedown', handleOutsideClick);
      };
    }
  }, [sideMenuOpen, toggleSideMenu]);

  return (
    // header start
    <header id="masthead" className="header prt-header-style-01">
      {/* site-header-menu */}
      <MarqueeSection/>
      <div id="site-header-menu" className="site-header-menu">
        <div className={`site-header-menu-inner prt-stickable-header ${isScrolled ? 'fixed-header' : ''}`}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                {/* site-navigation */}
                <div className="site-navigation d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="side-menu-container">
                      <div className="side-menu">
                        <a href="/" onClick={(e) => { e.preventDefault(); toggleSideMenu(); }}>
                          <i className="icon-menu"></i>
                        </a>
                      </div>
                      {/* Side Menu */}
                      <div className={`side-overlay ${sideMenuOpen ? 'on' : ''}`}>
                        <div className="side">
                          <a href="/" className="close-side" onClick={(e) => { e.preventDefault(); toggleSideMenu(); }}>
                            <i className="icon-close"></i>
                          </a>
                          <div className="row g-0">
                            <div className="col-lg-6">
                              <div className="menu-floating-menu-container bg-base-dark">
                                <ul id="menu-floating-menu-1" className="menu">
                                  <li className="menu-item">
                                    <a href="/club-corredores">Club de Corredores</a>
                                  </li>
                                  <li className="menu-item">
                                    <a target="_blank" rel="noreferrer noopener" href="https://formacion.equipomag.com">Formación y aprendizaje</a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="bg-base-grey">
                                <div className="slide-menu-info">
                                  <div>
                                    <div className="slide-menu-address">
                                      <div className="slide-menu-adress-text">
                                        Avenida de Andalucía, 37 - Alcalá del Río (Sevilla)
                                        <br />
                                        41200 España.
                                        <br />
                                        <a
                                        target="_blank" rel="noreferrer noopener"   href="tel:+34621234462"
                                          className="adress-text-link"
                                        >
                                          +34 621 234 462
                                        </a>
                                        <br />
                                        o háblanos al{" "}
                                        <a
                                         target="_blank" rel="noreferrer noopener"  href="https://wa.me/+34621234462"
                                          className="adress-text-link"
                                        >
                                          WhatsApp
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="slide-menu-social-main">
                                    <SocialLinks />
                                    <div className="slide-menu-copyright">
                                      <div className="slide-menu-copyright-text">
                                        Coypyright © {new Date().getFullYear()} EquipoMAG. Todos los derechos reservados.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Side Menu end */}
                    </div>
                    {/* site-branding */}
                    <div className="site-branding">
                      <h1>
                        <a
                          className="home-link"
                          href="/"
                          title="EquipoMAG"
                          rel="home"
                        >
                          <img
                            id="logo-img"
                            height="80"
                            width="180"
                            className="img-fluid auto_size"
                            src="/assets/images/logo.svg"
                            alt="WhatsApp: 💬 +34621234462"
                          />
                        </a>
                      </h1>
                    </div>
                    {/* site-branding end */}
                  </div>
                  <div className="d-flex align-items-center">

                    {/* main menu */}
                    <MainMenu />
                    {/* main menu end */}
                    {/* header_extra */}
                    <div className="header_extra">
                      <SocialLinks />
                    </div>
                    {/* header_extra end */}
                  </div>
                </div>
                {/* site-navigation end */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* site-header-menu end */}
    </header>
    // header end
  );
};

export default Header;
